import axios from "axios";
import {RACK_MANAGEMENT_LIST, RACK_MANAGEMENT_LIST_V2} from '../../config/stck.links'
import {toast} from 'react-toastify'

export const FETCH_STCK_RACK_LIST = 'FETCH_STCK_RACK_LIST'
export const RECEIVE_STCK_RACK_LIST = 'RECEIVE_STCK_RACK_LIST'
export const FAILED_STCK_RACK_LIST = 'FAILED_STCK_RACK_LIST'

export function fetchStckRack(){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_STCK_RACK_LIST});
        axios({
            method: 'post',
            url: RACK_MANAGEMENT_LIST,
            headers: {
                Authorization: auth
            },
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_STCK_RACK_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_STCK_RACK_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_STCK_RACK_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_STCK_RACK_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_STCK_RACK_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_STCK_RACK_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_STCK_RACK_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}

export function fetchStckRackByWa(id_warehouse_area){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_STCK_RACK_LIST});
        axios({
            method: 'post',
            url: RACK_MANAGEMENT_LIST_V2,
            headers: {
                Authorization: auth
            },
            data:{
                id_warehouse_area
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_STCK_RACK_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_STCK_RACK_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_STCK_RACK_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_STCK_RACK_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_STCK_RACK_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_STCK_RACK_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_STCK_RACK_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}
